const Header = {
  el: $("header.header"),

  init() {
    Header.events();
    Header.megamenu();
    Header.mobile();

    Header.scroll();
    $(window).on("scroll", Header.scroll);
  },

  events() {
    $(".header__toggle").on("click", function () {
      $(this).toggleClass("burger--open");
      $("header.header").toggleClass("header--menu-open");

    });
  },

  megamenu() {
    $(".header-menu .menu-item.menu-item-has-children").on(
      "click",
      function (e) {
        const menuItem = $(e.currentTarget);
        const menuLabel = menuItem.find("> .sub-menu > .menu-item__parent");

        const parentEl = menuItem.children(".menu-item__wrap").html();

        menuLabel.html(
          `${parentEl} <button class="btn menu-item__close"></button>`
        );

        $(".header-menu .menu-item__close").on("click", function (e) {
          setTimeout(() => {
            menuItem.removeClass("open");
          }, 50);
        });
      }
    );

    if (window.outerWidth < 900) {
      $(".header-menu a").on("click", function (e) {
        const wrapEl = $(this).parent();
        if (wrapEl.next().hasClass("sub-menu")) {
          e.preventDefault();
        }

        $(this).toggleClass("active");
        wrapEl.next(".sub-menu").slideToggle();
      });
      return;
    }
    let timeout;
    if (window.outerWidth > 900) {
      $(".header-menu .menu-item-has-children.megamenu")
        .on("mouseenter", function () {
          $("header.header").addClass("header--megamenu-open");
          $("html").addClass("no-scroll");
          timeout = setTimeout(() => {
            $(this).children(".sub-menu").addClass("open");
          });
        })
        .on("mouseleave", function () {
          $(".header-menu .menu-item-has-children.open").removeClass("open");
          $("header.header").removeClass("header--megamenu-open");
          $("html").removeClass("no-scroll");
          clearTimeout(timeout);
          $(this).children(".sub-menu").removeClass("open");
        });

      $(
        ".header-menu .menu-item > .sub-menu > .menu-item > .sub-menu > .menu-item-has-children > .menu-item__wrap > a"
      ).on("click", function (e) {
        e.preventDefault();
        $(this).closest(".menu-item").addClass("open");
      });
    }
  },

  mobile() {
    // toggle main navigation mobile
    $(".toggle-menu").on("click", function (e) {
      e.preventDefault();
      $(this).toggleClass("burger--open");

      Header.el.toggleClass(
        "header--was-scrolled",
        Header.el.hasClass("header--scrolled")
      );
      Header.el.toggleClass("header--mobile-open");

      $("html").toggleClass("no-scroll");
    });

    // Submenu functionality
    $(".menu-item-has-children").click(function (event) {
      if (
        $(event.target).hasClass("menu-item-has-children") &&
        $(window).width() < 993
      )
        $(".sub-menu", this).slideToggle(300);
    });
  },

  scroll() {
    if ($(window).scrollTop() > 100) {
      Header.el.addClass("header--scrolled");
    } else {
      Header.el.removeClass("header--scrolled");
    }
  },
};

export default Header;
